import { useEffect } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { OperationUnavailableMessage } from './OperationUnavailableMessage';
import { APP_LINKS } from '@/helpers/links';
import s from './index.module.scss';

const TABS = t => [
  { label: t('funds:tabs.add_cash'), path: APP_LINKS.addFunds },
  { label: t('funds:tabs.withdraw'), path: APP_LINKS.withdraw },
  { label: t('funds:tabs.bank_accounts'), path: APP_LINKS.bankAccounts },
];

const FundsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    if (location.pathname === APP_LINKS.cash) {
      navigate(APP_LINKS.addFunds, { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <div className={s.page}>
      <div className="g-container">
        <div className={s.inner}>
          <h1 className={classnames(s.title, 'f-headline-md f-500')}>
            {t('funds:page.cash')}
          </h1>
          <OperationUnavailableMessage className={s.warning} />
          <div className={s.links}>
            {TABS(t).map(tab => (
              <NavLink
                key={tab.path}
                to={tab.path}
                className={({ isActive }) =>
                  classnames(
                    s.link,
                    isActive && s.link_selected,
                    'f-body-md',
                    'f-500',
                  )
                }
              >
                {tab.label}
              </NavLink>
            ))}
          </div>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default FundsPage;
